import React from 'react';
import moment from 'moment';

const LuxuryMagazineTemplate = ({ packageData, user }) => {
    if (!packageData?.package) return <div>Loading...</div>;
    const { package: pkg } = packageData;

    // --- Style Palette ---
    const primaryTextColor = '#4A4A4A';
    const accentColor = '#B8860B'; // Gold
    const lightGray = '#ddd';
    const backgroundColor = '#F5F5F5';

    // --- Helper for Section Titles ---
    const SectionTitle = ({ children }) => (
        <h2 style={{
            fontFamily: "'Playfair Display', serif",
            textAlign: 'center',
            fontSize: '32px',
            marginBottom: '30px',
            color: primaryTextColor
        }}>
            {children}
        </h2>
    );

    return (
        <div style={{ fontFamily: "'Garamond', 'Times New Roman', serif", color: primaryTextColor }}>
             {/* Add Google Fonts for special typography */}
            {/* <style>
                {`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Lato:wght@400;700&display=swap');`}
            </style> */}
            
            {/* Hero Section */}
            <div style={{ position: 'relative', height: '400px', color: 'white', marginBottom: '40px' }}>
                <img src={pkg.imageSrc} alt={pkg.packageName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.2) 100%)' }}></div>
                <div style={{ position: 'absolute', bottom: '30px', left: '30px' }}>
                    <p style={{ fontFamily: "'Lato', sans-serif", textTransform: 'uppercase', letterSpacing: '2px', margin: 0, fontSize: '16px' }}>Your Journey To</p>
                    <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '48px', margin: '5px 0 0', fontWeight: 'bold', color: '#ffff' }}>{pkg.packageName}</h1>
                </div>
                {user?.logo && <img src={user.logo} alt="Logo" style={{ position: 'absolute', top: '20px', right: '20px', maxHeight: '50px', background: 'rgba(255,255,255,0.8)', padding: '5px', borderRadius: '3px' }} />}
            </div>

            {/* Welcome & Summary */}
            <div style={{ padding: '0 30px', marginBottom: '40px', display: 'flex' }}>
                <div style={{ flex: 3, paddingRight: '30px', borderRight: `1px solid ${lightGray}` }}>
                    <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: '28px' }}>An Unforgettable Experience Awaits</h2>
                    <p style={{ fontFamily: "'Lato', sans-serif", fontSize: '15px', lineHeight: '1.7' }}>{pkg.description}</p>
                </div>
                <div style={{ flex: 1, paddingLeft: '30px', fontFamily: "'Lato', sans-serif" }}>
                    <h4 style={{ margin: '0 0 15px 0', fontSize: '16px', fontWeight: 'bold' }}>TRIP DETAILS</h4>
                    <p style={{ margin: '0 0 10px' }}><strong>Duration:</strong> {pkg.duration}</p>
                    <p style={{ margin: '0 0 10px' }}><strong>Date:</strong> {moment(pkg.startedDate).format("D MMMM YYYY")}</p>
                    <p style={{ margin: '0', fontSize: '20px' }}><strong>Price:</strong> <span style={{ color: accentColor }}>{pkg.price} {pkg.currency}</span></p>
                </div>
            </div>

            {/* Itinerary Timeline */}
            {packageData.itineraries?.length > 0 && (
                <div style={{ padding: '0 30px', marginBottom: '40px' }}>
                    <SectionTitle>Your Itinerary</SectionTitle>
                    {packageData.itineraries.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, index) => (
                        <div key={index} style={{ display: 'flex', marginBottom: '25px' }}>
                            <div style={{ flex: '0 0 120px', textAlign: 'right', paddingRight: '20px', fontFamily: "'Lato', sans-serif" }}>
                                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>DAY {index + 1}</div>
                                <div style={{ fontSize: '14px', color: '#888' }}>{moment(item.date).format("MMM D")}</div>
                            </div>
                            <div style={{ borderLeft: `2px solid ${accentColor}`, paddingLeft: '20px', flex: 1 }}>
                                <h4 style={{ fontFamily: "'Playfair Display', serif", margin: '0 0 5px' }}>{item.title}</h4>
                                <p style={{ fontFamily: "'Lato', sans-serif", margin: 0 }}>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* --- FLIGHT & ACCOMMODATION DETAILS --- */}
            {(packageData.flightBookings?.length > 0 || packageData.hotelBookings?.length > 0) && (
                <div style={{ backgroundColor, padding: '40px 30px', marginBottom: '40px' }}>
                    <SectionTitle>Travel & Accommodations</SectionTitle>
                    <div style={{ display: 'flex', gap: '30px' }}>
                        {packageData.flightBookings?.length > 0 && (
                            <div style={{ flex: 1 }}>
                                <h3 style={{ fontFamily: "'Playfair Display', serif" }}>Air Travel</h3>
                                {packageData.flightBookings.map((flight, i) => (
                                    <div key={i} style={{ borderBottom: `1px solid ${lightGray}`, padding: '15px 0' }}>
                                        <p style={{ margin: 0, fontFamily: "'Lato', sans-serif", fontWeight: 'bold' }}>{flight.departureCity} → {flight.arrivalCity}</p>
                                        <p style={{ margin: '5px 0 0', fontFamily: "'Lato', sans-serif", fontSize: '14px', color: '#666' }}>{flight.airline} {flight.flightNumber}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        {packageData.hotelBookings?.length > 0 && (
                             <div style={{ flex: 1 }}>
                                <h3 style={{ fontFamily: "'Playfair Display', serif" }}>Your Stays</h3>
                                {packageData.hotelBookings.map((hotel, i) => (
                                    <div key={i} style={{ borderBottom: `1px solid ${lightGray}`, padding: '15px 0' }}>
                                        <p style={{ margin: 0, fontFamily: "'Lato', sans-serif", fontWeight: 'bold' }}>{hotel.hotelName}</p>
                                        <p style={{ margin: '5px 0 0', fontFamily: "'Lato', sans-serif", fontSize: '14px', color: '#666' }}>{hotel.city} | {hotel.roomType}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
            
            {/* --- SIGHTSEEING & TRANSFERS --- */}
            {(packageData.sightSeeings?.length > 0 || packageData.transfers?.length > 0) && (
                 <div style={{ padding: '0 30px', marginBottom: '40px' }}>
                    <SectionTitle>Activities & Logistics</SectionTitle>
                     {packageData.sightSeeings?.length > 0 && (
                        <div style={{ marginBottom: '30px' }}>
                             <h3 style={{ fontFamily: "'Playfair Display', serif" }}>Featured Experiences</h3>
                             <ul style={{ padding: 0, listStyle: 'none' }}>
                                {packageData.sightSeeings.map((sight, i) => (
                                    <li key={i} style={{ padding: '10px 0', borderBottom: `1px dotted ${lightGray}`, fontFamily: "'Lato', sans-serif" }}>
                                        <strong>{sight.sightseeingName}</strong> in {sight.destination}
                                    </li>
                                ))}
                             </ul>
                        </div>
                     )}
                     {packageData.transfers?.length > 0 && (
                         <div>
                             <h3 style={{ fontFamily: "'Playfair Display', serif" }}>Private Transfers</h3>
                              <ul style={{ padding: 0, listStyle: 'none' }}>
                                {packageData.transfers.map((transfer, i) => (
                                    <li key={i} style={{ padding: '10px 0', borderBottom: `1px dotted ${lightGray}`, fontFamily: "'Lato', sans-serif" }}>
                                        <strong>{moment(transfer.date).format("MMM D")} at {transfer.pickupTime}:</strong> {transfer.fromLocation} to {transfer.toLocation}
                                    </li>
                                ))}
                             </ul>
                         </div>
                     )}
                 </div>
            )}

            {/* Includes & Excludes */}
            <div style={{ backgroundColor, padding: '40px 30px', fontFamily: "'Lato', sans-serif", marginBottom: '40px' }}>
                 <SectionTitle>The Finer Details</SectionTitle>
                 <div style={{ display: 'flex', gap: '40px' }}>
                    {packageData.includes?.length > 0 && (
                        <div style={{flex: 1}}>
                            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '22px' }}>Inclusions</h3>
                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {packageData.includes.map((item, i) => <li key={i} style={{ padding: '8px 0', borderBottom: `1px solid ${lightGray}` }}>{item.description}</li>)}
                            </ul>
                        </div>
                    )}
                    {packageData.excludes?.length > 0 && (
                        <div style={{flex: 1}}>
                            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '22px' }}>Exclusions</h3>
                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {packageData.excludes.map((item, i) => <li key={i} style={{ padding: '8px 0', borderBottom: `1px solid ${lightGray}` }}>{item.description}</li>)}
                            </ul>
                        </div>
                    )}
                 </div>
            </div>
            
            {/* --- TERMS & CONDITIONS --- */}
            {packageData.termsandConditions?.length > 0 && (
                 <div style={{ padding: '0 30px', marginBottom: '40px' }}>
                    <SectionTitle>Terms & Conditions</SectionTitle>
                    {packageData.termsandConditions.map((term, i) => (
                        <div key={i} style={{ marginBottom: '20px' }}>
                             <h4 style={{ fontFamily: "'Playfair Display', serif", fontSize: '18px' }}>{term.title}</h4>
                             <p style={{ fontFamily: "'Lato', sans-serif", lineHeight: '1.6', color: '#666' }}>{term.description}</p>
                        </div>
                    ))}
                 </div>
            )}


            {/* Footer */}
            <footer style={{ textAlign: 'center', padding: '30px', fontFamily: "'Lato', sans-serif", fontSize: '14px', borderTop: `1px solid ${lightGray}` }}>
                <p><strong>Contact Us:</strong> {pkg.contactEmail} | {pkg.contactPhoneNumber}</p>
                <p style={{ color: '#999', marginTop: '10px' }}>We look forward to creating unforgettable memories with you.</p>
            </footer>
        </div>
    );
};

export default LuxuryMagazineTemplate;